import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useLedgerApi } from '../api';
import { ICauseLifetime } from '../types';

type UpdateCauseLedgerAccountCodeRequest = {
  causeId?: string;
  accountCode?: ICauseLifetime['account_code'];
  storeItemId?: string;
};

// update account code
const useUpdateCauseLedgerAccountCode = () => {
  const LedgerApi = useLedgerApi();
  const queryClient = useQueryClient();
  const updateAccountCode = async ({
    accountCode,
    causeId,
  }: UpdateCauseLedgerAccountCodeRequest) => {
    const { data } = await LedgerApi.put(`/causes/${causeId}/account_code`, {
      cause: { account_code: accountCode },
    });

    return data;
  };

  return useMutation({
    mutationFn: updateAccountCode,
    onSuccess: (data, variables) => {
      const { causeId } = variables;
      return queryClient.invalidateQueries({
        queryKey: ['ledger', 'cause', causeId],
      });
    },
  });
};

export { useUpdateCauseLedgerAccountCode };
export type { UpdateCauseLedgerAccountCodeRequest };
